export default {
  columns: {
    mobile: 4,
    tablet: 12,
    desktop: 12
  },
  margins: {
    mobile: '3%',
    tablet: '7%',
    desktop: '7%'
  },
  gutter: 2
}



// WEBPACK FOOTER //
// ./src/core/theme/gridSettings.js